(function () {
    'use strict';

    angular
        .module('app.tasks')
        .controller('TasksTemplatesController', TasksTemplatesController);

    TasksTemplatesController.$inject = ['common', 'dataservice', 'config'];
    /* @ngInject */
    function TasksTemplatesController(common, dataservice, config) {
        var vm = this;
        vm.title = 'Task Templates';
        vm.displayedItems = [];
        vm.items = [];

        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(config.events.refreshCounts);
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/Tasks/GetTemplates').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }
    }
})();
